export const UPDATE_MASTERCARD_PROMO_STATUS = 'events/UPDATE_MASTERCARD_PROMO_STATUS';
